import Router from 'vue-router'
import { constantRouterMap } from './constantRouter'
import Vue from 'vue'

Vue.use(Router)

const createRouter = () =>
  new Router({
    mode: 'history',
    routes: constantRouterMap
  })

const router = createRouter()

// 路由切换前销毁观察器
router.beforeEach((to, from, next) => {
  if (to.name !== 'aboutUs' || !to.hash) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }
  next()
})

router.afterEach(() => {
  if (Vue.prototype.$lazyObserver && !Vue.prototype.$lazyObserver.observer) {
    Vue.prototype.$lazyObserver.initObserver()
  }
  if (
    Vue.prototype.$moveInObserver &&
    !Vue.prototype.$moveInObserver.observer
  ) {
    Vue.prototype.$moveInObserver.initObserver()
  }
})
export default router
